webpackJsonp([174759553322802],{

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var blogList = [{
	    heading: "Migrating to the cloud — let APM Analytics Show You the Way",
	    description: "Transitioning distributed applications to the fast-changing environment of the cloud is a complex and risky process.",
	    link: "http://www.appdynamics.com/blog/cloud/application-performance-management-in-the-cloud/"
	}, {
	    heading: "Self Tuning Applications in the Cloud: It’s about time!",
	    description: "In my previous blog I’ve written about the hard work needed to successfully migrate applications to the cloud. But why go through all that work to get to the cloud?",
	    link: "http://www.appdynamics.com/blog/cloud/self-tuning-applications-in-the-cloud-its-about-time/"
	}, {
	    heading: "Planning for Failure with APM",
	    description: "If you are running mission-critical applications and do not have a strategy to deal with failure, you are putting your whole organization at risk.",
	    link: "http://www.appdynamics.com/blog/apm/planning-for-failure-with-application-performance-management-apm/"
	}, {
	    heading: "An Introduction to the Data Cloud",
	    description: "As data has grown exponentially at many sites, companies have been forced to horizontally scale their data.Some have turned to sharding of databases like Postgres or MySQL, while others have switched to newer NoSQL data systems",
	    link: "http://www.appdynamics.com/blog/cloud/an-introduction-to-the-data-cloud/"
	}, {
	    heading: "Data Cloud",
	    description: "In my previous blog, I wrote at length about the complexities of running a data cloud in production. This logical data set, spread across many nodes, requires a whole new set of tools and methodologies to run and maintain .",
	    link: "http://www.appdynamics.com/blog/cloud/data-clouds-part-ii-my-big-data-dashboard/"
	}, {
	    heading: "DevOps Days Toronto",
	    description: "The DevOps Metrics Panel, during this event, conducted in depth discussions on Metrics, which is  a standard for measuring or evaluating something. The most relevant one being the one that uses figures or statistics. ",
	    link: "https://devops.uberflip.com/h/i/81761355-devops-days-toronto-2015-day-2"
	}, {
	    heading: "Best Practice - Business Transaction Strategy",
	    description: "Your application performance is reflected to a great extent through business transactions. Optimized business transactions give valuable information that accurately show what is happening in your application environment.",
	    link: "https://player-sql.cyberu.com/2004/lms.aspx?hash=eE1GWkN1QnIxWGFSQmVHaGJUR2NuUU1NRkExdHZGVnJhdmtnS01HWVVXdzRwYVFUUTNTZnFSOVVXUUhUWjN5cW5YTU5XZFNBYjRPZHRyNnNJNXVSdFdhekcxWDZZdndZK0xtNUdwUWRPeW02L0dDYkFWdnk5bUEzSjUwOHdQN0VDYnpLN1BadE5QNGFUVDRIdWNGTlJuTHRCV05OMlJPdE4yRUp6ek1uUHhVV2dRT29kU2ovMHcvaGt0ZXYzeklH"
	}, {
	    heading: "Application Mapping in AppDynamics",
	    description: "Your application environment is mapped into an organised hierarchical system of business applications, tiers, nodes and backends by App Dynamics. The latest magic quadrant for Application Performance Monitoring (APM) has been released by Gartner, two of which were Application Mapping and Transaction Profiling.",
	    link: "https://player-sql.cyberu.com/2004/lms.aspx?hash=eE1GWkN1QnIxWFlOSkR2MHkwR2krVkhiRWdKeGt5NjFUMlFWTlg1REJhK01uZjkrZ0gvcXdYODg1aEtLbytYRitmWGQ1b21rUlFnb1NxUUVPWDBzRDNqTG0zQVc1MzdsRDFaSkFxNXVwT04zVUlDNHdkMzg0bVBiUWQzRHJCcXMyOW9ENUUvakRQYk5RQ2QzMHhSNTJZOXdoZGdWL0NmUnNrRm5VVUIyQ1cwMEdWMGtkWUp1dSsxNlZhQ0pvTEli"
	}, {
	    heading: "Life After Sharding: Monitoring and Managing a Complex Data Cloud",
	    description: "Data systems have struggled to keep up with the rapid growth of application data. As a result, many have turned to sharding their data as a solution.",
	    link: "http://www.slideshare.net/OReillyOSCON/data-cloud-oscon"
	}, {
	    heading: "A Short History of Postgres",
	    description: "Implementation of the Postgres DBMS began in 1986. The initial concepts for the system were presented in [STON86] and the definition of the initial data model appeared in [ROWE87]. The design of the rule system at that time was described in [STON87a].",
	    link: "http://www.eskimo.com/support/PostgreSQL/tutorial/c0102.htm"
	}];
	
	exports.default = function () {
	    return Glamor.createElement(
	        "div",
	        { className: "content_sections", style: { paddingLeft: "16px", paddingRight: "16px" } },
	        Glamor.createElement(
	            "h1",
	            { style: { marginLeft: "24px" } },
	            "Articles"
	        ),
	        Glamor.createElement(
	            "span",
	            { className: "blog_overflow_container" },
	            blogList.map(function (blogitems, k) {
	                return Glamor.createElement(
	                    "span",
	                    { key: k, className: "resourses_row" },
	                    Glamor.createElement(
	                        "a",
	                        { href: blogitems.link, target: "_blank", className: "blog_topics" },
	                        blogitems.heading
	                    ),
	                    Glamor.createElement(
	                        "span",
	                        { className: "blog-description" },
	                        blogitems.description
	                    ),
	                    Glamor.createElement(
	                        "a",
	                        { target: "_blank", href: blogitems.link, className: "blog_readmore" },
	                        "Read More..."
	                    )
	                );
	            })
	        )
	    );
	};
	
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),

/***/ 120:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-articles-js-873f9851155a5aaa9a59.js